const CLAVE_USUARIO = "usuarioSIGEDI";
const VERSION_SESION = "2";

const usuarioVacio = {
  id: null,
  nombre: "",
  apellido: "",
  identificacion: null,
  dni: null,
  sedeID: null,
  destino: null,
  nivel: null,
  estado: null,
  blanqueoContrasena: 0,
  dependenciaNombre: "",
  funcion: "",
  createdAt: null,
  updatedAt: null,
};

const limpiarSesionIncompatible = () => {
  localStorage.removeItem("usuarioSIGEDI");
  localStorage.removeItem("tokenJWT");
  localStorage.removeItem("versionSesionSIGEDI");
};

const ObtieneDatosCookies = () => {
  try {
    const versionGuardada =
      localStorage.getItem("versionSesionSIGEDI");

    if (versionGuardada !== VERSION_SESION) {
      limpiarSesionIncompatible();

      return { ...usuarioVacio };
    }

    const usuarioGuardado =
      localStorage.getItem(CLAVE_USUARIO);

    if (!usuarioGuardado) {
      return { ...usuarioVacio };
    }

    const usuario = JSON.parse(usuarioGuardado);

    if (
      !usuario ||
      typeof usuario !== "object" ||
      usuario.versionSesion !== VERSION_SESION
    ) {
      limpiarSesionIncompatible();

      return { ...usuarioVacio };
    }

    return {
      ...usuarioVacio,
      ...usuario,

      id: usuario.id ?? null,
      nombre: usuario.nombre ?? "",
      apellido: usuario.apellido ?? "",

      identificacion:
        usuario.identificacion ??
        usuario.dni ??
        null,

      dni:
        usuario.dni ??
        usuario.identificacion ??
        null,

      sedeID: usuario.sedeID ?? null,
      destino: usuario.destino ?? null,
      nivel: usuario.nivel ?? null,
      estado: usuario.estado ?? null,

      blanqueoContrasena:
        usuario.blanqueoContrasena ??
        0,

      dependenciaNombre:
        usuario.dependenciaNombre ??
        "",

      funcion: usuario.funcion ?? "",
    };
  } catch (error) {
    console.error(
      "Error recuperando usuario:",
      error
    );

    limpiarSesionIncompatible();

    return { ...usuarioVacio };
  }
};

export default ObtieneDatosCookies;